var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reload-report",class:{
    'reload-report--loading': _vm.loading,
  },on:{"click":_vm.onClick}},[_c('gl-icon',{attrs:{"gray":"","height":24,"name":"reload-2","width":24}}),_c('span',{staticClass:"reload-report__text"},[_vm._v(" "+_vm._s(_vm.reloadText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }